import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { html } from 'lit';
import type { KPF } from '../KPF.js';

@Entity()
export class KPFAspect extends AbstractAspect {
  static override _class = 'KPFAspect';

  constructor(doc: PartialEntityData<KPFAspect>) {
    const newDoc = {
      customID: 'kpfs',
      ...doc,
    };
    super(newDoc);
  }

  @Field(() => ID) value: Maybe<string>;
  @Field(() => String) kuerzel: Maybe<string>;
}

export const KPFAspectSchema: AspectConfig<KPFAspect> = {
  aspectConstructor: KPFAspect,
  renderEditor: ({ aspectValue }) => html`
    <chancen-component-semantic-kpf-picker
      placeholder-mode="hide"
      @value-picked=${(e: ValueEvent<Maybe<KPF<any>>>) => {
        aspectValue.value = e.detail.value?._id ?? null;
        aspectValue.kuerzel = e.detail.value?.kuerzel ?? null;
      }}
      .valueID=${aspectValue.value}
    ></chancen-component-semantic-kpf-picker>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.kuerzel ? html` ${aspectValue.kuerzel} ` : null),
};
